/**
 * Protected Route Component
 *
 * Wraps routes that require authentication and optionally role-based access.
 * Redirects to login page if user is not authenticated.
 * Redirects to dashboard if user lacks required role.
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requiresFullAdmin = false }) => {
  const { user, loading, isFullAdmin } = useAuth();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-daring-teal mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  // Redirect to dashboard if user lacks required role
  if (requiresFullAdmin && !isFullAdmin) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  // Render protected content
  return children;
};

export default ProtectedRoute;
